import { useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { getPAGAA000, getPAHAF020 } from '../../../services/Api';
import Nav from '../../../shared/components/Nav';
import { MENU_CUSTOMER_SERVICE_CENTER } from '../../../shared/constants/app';
import { formatDate, updateMenuVisibility } from '../../../utils';
import { decodeHTML } from 'entities';

const PAHAF020 = () => {
    const { id } = useParams();
    const [data, setData] = useState({});
    const [customerServiceMenu, setCustomerServiceMenu] = useState([]);
    const navigate = useNavigate();

    const getGubun = (gubun) => {
        switch (gubun) {
            case '01':
                return '공지';
            case '02':
                return '소식';
            default:
                return '';
        }
    };

    useEffect(() => {
        getPAGAA000()
            .then(({ data }) => {
                const updatedCustomerServiceMenu = updateMenuVisibility(data, MENU_CUSTOMER_SERVICE_CENTER);
                setCustomerServiceMenu(updatedCustomerServiceMenu);
            })
            .catch((error) => console.log(error));
    }, []);

    useEffect(() => {
        getPAHAF020(id)
            .then(({ data }) => {
                setData(data);
            })
            .catch((error) => {
                console.log(error);
                navigate('/pahaf010');
            });
    }, [id, navigate]);
    return (
        <div id="content">
            <Nav menu={customerServiceMenu} />
            <div id="tableVolunteer">
                <div className="header-frame">
                    <h3 className="vln__tit vln__tit--pt44">공지/소식</h3>
                </div>
                <div className="vln-mgzn__detail">
                    <div className="vln-mgzn__top">
                        <div className="vln-mgzn__lf">
                            <span
                                className={`vln-mgzn__gb ${
                                    data?.gubun === '01' ? 'blue' : data?.gubun === '02' ? 'green' : ''
                                } `}
                            >
                                {getGubun(data?.gubun)}
                            </span>
                            <div className="vln-mgzn__tit">
                                <h3>{data?.title}</h3>
                            </div>
                        </div>
                        <div className="vln-mgzn__view">{formatDate(data?.addDate)}</div>
                    </div>
                    <div
                        className="vln-mgzn__cnt"
                        dangerouslySetInnerHTML={{
                            __html: decodeHTML(data?.contents || ''),
                        }}
                    ></div>
                </div>
                <div className="vln-btnbx">
                    <Link to="/pahaf010" className="vln-listbtn">
                        목록
                    </Link>
                </div>
            </div>
        </div>
    );
};
export default PAHAF020;
